import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export const useCartNavigation = (customBusinessType, customRestaurantId, customDeliveryMode) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id: paramRestaurantId } = useParams();

  const query = new URLSearchParams(location.search);
  const activeMode = customDeliveryMode || query.get("tab") || query.get("deliveryType");

  const cartItems = useSelector((state) => state.restaurantCart.items) || [];
  const reduxRestaurantId = useSelector(
    (state) => state.restaurantCart.restaurantId
  );
  const reduxBusinessType = useSelector(
    (state) => state.restaurantCart.businessType
  );

  const bucketOf = (item) => {
    return (item?.detail?.deliveryDateType || item?.deliveryDateType || "same_day") === "same_day"
      ? "same_day"
      : "next_day";
  };

  const filteredCartItems = activeMode
    ? cartItems.filter((i) => bucketOf(i) === activeMode)
    : cartItems;

  const cartCount = filteredCartItems.reduce(
    (total, item) => total + (item.quantity || 1),
    0
  );

  const handleCartClick = () => {
    const currentTabType = location.pathname.includes("/raw_food")
      ? "raw_food"
      : location.pathname.includes("/store")
        ? "store"
        : customBusinessType || "restaurant";

    const matchedItem =
      filteredCartItems.find(
        (i) =>
          i.businessType === currentTabType ||
          i.detail?.businessType === currentTabType
      ) || filteredCartItems[0] || cartItems[0];

    const activeId =
      customRestaurantId ||
      paramRestaurantId ||
      matchedItem?.businessId ||
      matchedItem?.restaurantId ||
      matchedItem?.detail?.restaurant_id ||
      matchedItem?.detail?.businessId ||
      matchedItem?.detail?.restaurantId ||
      cartItems[0]?.businessId ||
      cartItems[0]?.restaurantId ||
      cartItems[0]?.detail?.restaurant_id ||
      cartItems[0]?.detail?.businessId ||
      cartItems[0]?.detail?.restaurantId ||
      reduxRestaurantId;

    const activeType =
      customBusinessType ||
      matchedItem?.businessType ||
      matchedItem?.detail?.businessType ||
      reduxBusinessType ||
      currentTabType;

    const deliveryQuery = activeMode ? `?deliveryType=${activeMode}` : "";

    if (activeId) {
      navigate(`/${activeType}/${activeId}/cart${deliveryQuery}`);
    } else if (cartItems.length > 0) {
      navigate(`/checkout${deliveryQuery}`);
    }
  };

  return { handleCartClick, cartCount, cartItems: filteredCartItems, totalCartItems: cartItems };
};
